import BacnetObjectValue from './BacnetObjectValue';

export default class BacnetObjectsWriteValuesRequestModel {
  public readonly bacnetObjectValues: BacnetObjectValue[];

  constructor(bacnetObjectValues: BacnetObjectValue[]) {
    this.bacnetObjectValues = bacnetObjectValues;
  }
}
